import React, { useState, useEffect } from "react";
import EventAI1 from "./components/EventAI1";
import EventAI2 from "./components/EventAI2";
import { useLocation } from "react-router-dom";
// import axios from "axios";
import { useNavigate } from "react-router-dom";
// import { set } from "date-fns";

const EventMarketingAI = () => {

    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        category: "",
        district_name: "",
        age: "",
        channel: "",
        subChannel: "",
        theme: "이벤트",
        customMenu: "",
        customText: "",
        prompt : "",
        style : ""
    });

    const updateFormData = (newData) => {
        setFormData((prev) => ({ ...prev, ...newData }));
    };

    const goNext = () => setStep((prev) => Math.min(prev + 1, 5));
    const goBack = () => setStep((prev) => Math.max(prev - 1, 1));

    const location = useLocation();
    const data = location.state.data;
    
    // const aiChannel = localStorage.getItem("aiChannel") || "1";
    // const aiAge = localStorage.getItem("aiAge") || "3";
    // const aiStyle = localStorage.getItem("aiStyle") || "1";
    const userMenu = localStorage.getItem("customMenu")

    // const storeBusinessNumber = data.store_business_number;

    useEffect(() => {
        if (data) {
            setFormData((prev) => ({
            ...prev,
            ...data, 
            }));
        }
    }, [data]);


    const manualData = {
        ...formData,
        store_name : data.store_name,
        road_name : data.road_name,
        detail_category_name : data.detail_category_name,
        store_business_number: data.store_business_number,
        main: data.main,
        temp: data.temp,
        theme: "이벤트",
        // aiRec: data.aiRec
    }

    // 최종 로딩창으로 넘기기
    const handleNewAdCreation = () => {
        navigate(`/event/marketing/ai/loading`, { state: manualData });
    };


    const navHome = () => {
        navigate("/ads/main", { state: { storeBusinessNumber: data.store_business_number } });
    };

    return (
        <div className="w-full h-screen bg-white">

            {step === 1 && (
                <EventAI1
                    data={formData}
                    updateData={updateFormData}
                    userMenu={userMenu}
                    onNext={goNext}
                    onBack={() => navigate(-1)}
                    onHome={navHome}
                />
            )}

            {step === 2 && (
                <EventAI2
                    data={formData}
                    exData={data}
                    updateData={updateFormData}
                    onBack={goBack}
                    onHome={navHome}
                    onNext={handleNewAdCreation}
                />
            )}
        </div>
    );
};

export default EventMarketingAI;
